define([
    'text!../views/pa-quick-quote.html',
    '../controllers/PAQuickQuoteCtrl'
], (PAQuickQuoteView, PAQuickQuoteCtrl)=> {
    return RootStates => {
        const parentState = RootStates.quote_bind;

        return {
            paQuickQuote: {
                parent: parentState,
                url: '/paquickQuote',
                controller: PAQuickQuoteCtrl,
                template: PAQuickQuoteView
            }
        };
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/config/RouteConfig.js
 **/